import React from "react"
import { Col, Container, Row } from "react-grid-system"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"
import Arrow from "../Arrow"
import { ContainerMuiXl } from "../ContainerMui"

const StyledAccorianHeaderWrapper = styled.div`
  font-family: "Open Sans", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.5em;
  width: 100%;

  cursor: pointer;
`

const StyledAccordianArrowWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 55%;
  transform-origin: center center;
  ${props => (props.isPointDown ? `transform: rotate(-90deg);` : null)};

  transition: transform linear 200ms;
`

const StyledTitleWrapper = styled.div`
  padding-top: 12px;
  padding-bottom: 12px;
`

const CollapsibleTriggerComponent = props => {
  return (
    <StyledAccorianHeaderWrapper
      style={{ backgroundColor: props.triggerBackgroundColor }}
    >
      <Container fluid xs sm md style={{ color: "#ffffff" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ flex: "0 1 auto", paddingRight: "15px" }}>
            <StyledTitleWrapper>
              <div
                style={{
                  textTransform: "uppercase",
                }}
              >
                {props.title}
              </div>
            </StyledTitleWrapper>
          </div>
          <div style={{ flex: "0 0 auto" }}>
            <StyledAccordianArrowWrapper isPointDown={props.isOpened}>
              <Arrow />
            </StyledAccordianArrowWrapper>
          </div>
        </div>
      </Container>
    </StyledAccorianHeaderWrapper>
  )
}

export default CollapsibleTriggerComponent
